import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const keyHintVariants = cva(
    'box-border inline-flex shrink-0 flex-row items-center justify-center self-center whitespace-nowrap rounded-[2px] pt-0.5 font-geist-mono text-[10px] font-normal leading-[10px]',
    {
        variants: {
            theme: {
                dark: 'bg-grey-500 text-grey-300',
                light: 'bg-grey-100 text-grey-300 shadow-[-0.5px_0.5px_0px_var(--grey-200)]',
            },
            size: {
                single: 'min-w-3.5 min-h-3.5 h-3.5 px-0',
                esc: 'h-3.5 w-7 px-1',
                enter: 'h-3.5 w-[26px] px-2',
            },
        },
        defaultVariants: {
            theme: 'dark',
            size: 'single',
        },
    },
);

export type KeyHintTheme = VariantProps<typeof keyHintVariants>['theme'];
export type KeyHintSize = VariantProps<typeof keyHintVariants>['size'];

export interface KeyHintProps
    extends
        VariantProps<typeof keyHintVariants>,
        React.HTMLAttributes<HTMLElement> {
    children: React.ReactNode;
}

export function KeyHint({
    theme,
    size = 'single',
    className,
    children,
    ...props
}: KeyHintProps) {
    return (
        <kbd
            className={cn(
                keyHintVariants({
                    theme,
                    size,
                }),
                className,
            )}
            {...props}
        >
            {children}
        </kbd>
    );
}
